import React from "react";

export interface FormProps
  extends React.DetailedHTMLProps<
    React.FormHTMLAttributes<HTMLFormElement>,
    HTMLFormElement
  > {
  children: React.ReactNode;
}

export default function Form({ children, ...props }: FormProps) {
  return (
    <form className="fl-flex fl-flex-col fl-space-y-4" {...props}>
      {children}
    </form>
  );
}
